// Casos Onsite Growth México — datos editables
// Bruno: reemplaza los números placeholder con los reales
// y agrega las URLs de YouTube cuando estén listas.

const PLACEHOLDER_DATOS = [
  { num: '—', label: 'Métrica por definir', color: 'mango' },
  { num: '—', label: 'Métrica por definir', color: 'turquesa' },
  { num: '—', label: 'Métrica por definir', color: 'coral' },
  { num: '—', label: 'Métrica por definir', color: 'verde' },
];

const PLACEHOLDER_PROCESO = [
  { icon: '📍', bold: 'Basecamp en sitio.', text: 'Viajamos al negocio y trabajamos codo a codo con el equipo.' },
  { icon: '🎥', bold: 'Documentamos todo.', text: 'Contenido real, sin actores, directo del negocio.' },
  { icon: '📈', bold: 'Lanzamos estrategia.', text: 'Identidad, redes y campañas funcionando.' },
];

const CASOS_ONSITE = [
  {
    slug: 'talabarteria-ga',
    name: 'Talabartería GA',
    eyebrow: 'FAMILIA · 20 AÑOS DE OFICIO',
    subtitle: 'Cinturones y artículos en piel hechos a mano',
    location: 'Jocotitlán · Edomex',
    quote: 'Somos una familia con 20 años trabajando la piel. Cada pieza la hacemos nosotros.',
    desc: 'Don Gabriel y sus hijas perfeccionan el arte de la talabartería en Jocotitlán. Cinturones, fundas y arneses cosidos uno por uno, sin máquinas industriales.',
    photo: '/cards/talabarteria-ga.jpg',
    gradient: 'linear-gradient(135deg, rgba(93,193,185,0.25), rgba(83,74,183,0.2))',
    heroGradient: 'radial-gradient(700px 400px at 70% 30%, rgba(253,190,2,.35), transparent 60%), linear-gradient(180deg,#241a12,#14141c)',
    datos: [
      { num: '2', label: 'Redes sociales abiertas desde cero (IG + FB)', color: 'mango' },
      { num: '+120%', label: 'Crecimiento en ventas vs. trimestre anterior', color: 'turquesa' },
      { num: '35', label: 'Videos y piezas de contenido producidas en sitio', color: 'coral' },
      { num: '12k', label: 'Personas alcanzadas el primer mes', color: 'verde' },
    ],
    proceso: [
      { icon: '📍', bold: 'Basecamp en el taller.', text: 'Fuimos a Jocotitlán y ayudamos a David, Eli y Angelita, trabajando codo a codo con la familia.' },
      { icon: '🎥', bold: 'Elevamos el negocio, no solo los videos.', text: 'Buscamos crecer su contenido y sus ventas con procesos completos, no únicamente grabando piezas.' },
      { icon: '📈', bold: 'Lanzamos campañas en vivo.', text: 'Identidad, catálogo y ventas por WhatsApp funcionando.' },
    ],
    videoUrl: '#', // Bruno: pegar URL de YouTube
  },
  {
    slug: 'rustico-el-once',
    name: 'Rústico El Once',
    eyebrow: 'CABAÑAS · NATURALEZA',
    subtitle: 'Cabañas en el bosque para desconectar',
    location: 'Amealco · Querétaro',
    quote: 'Cuando los huéspedes llegan, lo primero que dicen es: aquí se respira diferente.',
    desc: 'Cabañas de madera en medio del bosque queretano. Animales en libertad, hogueras al anochecer y cero señal de celular.',
    photo: '/cards/rustico-el-once.jpg',
    gradient: 'linear-gradient(135deg, rgba(253,190,2,0.2), rgba(235,99,107,0.15))',
    heroGradient: 'radial-gradient(700px 400px at 30% 30%, rgba(235,99,107,.35), transparent 60%), linear-gradient(180deg,#1a1216,#14141c)',
    datos: [
      { num: '#1', label: 'Estrategia SEO: keyword de pádel sin competencia en la zona', color: 'turquesa' },
      { num: '+85%', label: 'Aumento en reservas de fin de semana', color: 'mango' },
      { num: '4', label: 'Canales activados: web, Maps, IG y WhatsApp', color: 'verde' },
      { num: 'B2B', label: 'Nueva línea: team building corporativo para CDMX y Qro', color: 'coral' },
    ],
    proceso: [
      { icon: '📍', bold: 'Basecamp entre cabañas.', text: 'Vivimos la experiencia del huésped para contarla de verdad.' },
      { icon: '🔍', bold: 'Análisis competitivo.', text: 'Detectamos el nicho desatendido: pádel + eventos corporativos.' },
      { icon: '📈', bold: 'Posicionamiento local.', text: 'Google Maps, reseñas y contenido del bosque queretano.' },
    ],
    videoUrl: '#', // Bruno: pegar URL de YouTube
  },
  {
    slug: 'bike-park',
    name: 'Bike Park',
    eyebrow: 'DEPORTE · AVENTURA',
    subtitle: 'Pista de bicicletas en medio del bosque',
    location: 'Acambay · Edomex',
    quote: 'Queríamos un lugar donde la gente viniera a rodar y se olvidara de todo lo demás.',
    desc: 'Una pista de ciclismo de montaña enclavada en el bosque de Acambay. Circuitos para todos los niveles, saltos, curvas entre los árboles y la adrenalina de rodar rodeado de naturaleza pura.',
    photo: '/cards/bike-park.jpg',
    gradient: 'linear-gradient(135deg, rgba(29,158,117,0.25), rgba(93,193,185,0.15))',
    heroGradient: 'radial-gradient(700px 400px at 50% 30%, rgba(29,158,117,.35), transparent 60%), linear-gradient(180deg,#121a15,#14141c)',
    datos: PLACEHOLDER_DATOS,
    proceso: PLACEHOLDER_PROCESO,
    videoUrl: '#',
  },
  {
    slug: 'rac-pac',
    name: 'Rac Pac',
    eyebrow: 'HOJALATERÍA · PINTURA',
    subtitle: 'Hojalatería y pintura automotriz',
    location: 'Acambay · Edomex',
    quote: 'Cada carro que entra sale como nuevo. Ese es nuestro compromiso con la gente.',
    desc: 'Taller de hojalatería y pintura en Acambay. Reparación de carrocerías, enderezado, preparación y pintura automotriz con acabados profesionales y atención personalizada.',
    photo: '/cards/rac-pac.jpg',
    gradient: 'linear-gradient(135deg, rgba(235,99,107,0.2), rgba(253,190,2,0.15))',
    heroGradient: 'radial-gradient(700px 400px at 60% 30%, rgba(235,99,107,.35), transparent 60%), linear-gradient(180deg,#1a1214,#14141c)',
    datos: PLACEHOLDER_DATOS,
    proceso: PLACEHOLDER_PROCESO,
    videoUrl: '#',
  },
  {
    slug: 'tierra-alta',
    name: 'Tierra Alta',
    eyebrow: 'CAMPO · TRADICIÓN',
    subtitle: 'Productos del campo y tradición local',
    location: 'Atlacomulco · Edomex',
    quote: 'Lo que cosechamos aquí tiene historia. Cada producto viene de generaciones de trabajo.',
    desc: 'Un proyecto que nace de la tierra en Atlacomulco. Productos locales con raíz, conectando el campo con quienes valoran lo auténtico y lo hecho con las manos.',
    photo: '/cards/tierra-alta.jpg',
    gradient: 'linear-gradient(135deg, rgba(253,190,2,0.25), rgba(29,158,117,0.15))',
    heroGradient: 'radial-gradient(700px 400px at 40% 30%, rgba(253,190,2,.35), transparent 60%), linear-gradient(180deg,#1a1812,#14141c)',
    datos: PLACEHOLDER_DATOS,
    proceso: PLACEHOLDER_PROCESO,
    videoUrl: '#',
  },
  {
    slug: 'gloria-psicologia',
    name: 'Lic. Gloria Sarmiento',
    eyebrow: 'PSICOLOGÍA · COMUNIDAD',
    subtitle: 'Psicología con especialidad en Terapia Cognitivo Conductual',
    location: 'Santa María Yacochi · Oaxaca',
    quote: 'Quiero que mi pueblo hable de lo que siente. Que la salud mental no sea un tema prohibido.',
    desc: 'Primera psicóloga de su comunidad Mixe. Lleva terapia y pláticas a Santa María Yacochi para visibilizar el abuso sexual y abrir conversación sobre salud mental. Quiere usar redes sociales para multiplicar el impacto en su pueblo.',
    photo: '/cards/gloria.jpg',
    gradient: 'linear-gradient(135deg, rgba(175,169,236,0.25), rgba(83,74,183,0.15))',
    heroGradient: 'radial-gradient(700px 400px at 50% 30%, rgba(175,169,236,.35), transparent 60%), linear-gradient(180deg,#18141a,#14141c)',
    datos: PLACEHOLDER_DATOS,
    proceso: PLACEHOLDER_PROCESO,
    videoUrl: '#',
  },
];

export default CASOS_ONSITE;
